import $ from "jquery";

$(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
        $(".scrollToTop").fadeIn();
    } else {
        $(".scrollToTop").fadeOut();
    }
});

export default function scrollTo(position) {
    $('html, body').stop().animate({
        scrollTop: position
    }, 800);
}


// WEBPACK FOOTER //
// ./src/utils/scrollToTop.js